<template>
  <div v-if="!loading">
    <div class="d-flex">
      <b-button v-b-modal.edit-modal variant="primary" class="ml-auto p-2">
        <font-awesome-icon :icon="faPlusSquare" />
        {{ $t("list.new") }}
      </b-button>
    </div>
    <b-modal
      id="edit-modal"
      ref="edit-modal"
      :title="$t('modals.contact')"
      centered
      size="lg"
      :ok-title="$t('actions.submit')"
      :cancel-title="$t('actions.cancel')"
      @ok="addRelationshipItem"
      @hide="resetRelationShipItem"
    >
      <contact-form />
    </b-modal>
    <template v-if="relationshipItems.length">
      <b-table
        ref="table"
        :items="relationshipItems"
        :fields="visibleFields"
        borderless
        striped
        responsive
      >
        <template slot="checkbox" slot-scope="data">
          <b-checkbox v-model="data.item.selected" />
        </template>
        <template v-for="(field, i) in fields" :slot="`HEAD_${field.field}`">
          <list-table-header
            :key="i"
            :field="field"
            :sort-direction="sortDirection"
            :sort-by="sortBy"
          />
        </template>
        <template v-for="field in fields" :slot="field.field" slot-scope="data">
          <span :key="field.field">
            {{ data.item[field.field] }}
          </span>
        </template>
        <template slot="actions" slot-scope="data">
          <tab-table-actions
            :id="data.item['id']"
            @editItem="openEditModal"
            @removeItem="removeRelationshipItem"
          />
        </template>
      </b-table>
    </template>
    <template
      v-else
      class="w-100 h-100 d-flex align-items-center justify-content-center font-weight-bold"
    >
      <p>
        {{
          $t("list.no_data", { data: this.$t("menu.contacts").toLowerCase() })
        }}
      </p>
    </template>
  </div>
  <div v-else>
    <spinner />
  </div>
</template>

<script>
import api from '@/api/contacts'
import model from '@/models/contacts'
import relationship from '@/mixins/relationship'
import tabTableActions from '@/components/common/tabTableActions'
import listTableHeader from '@/components/common/listTableHeader'
import contactForm from '@/components/clients/contacts/form'
import { faPlusSquare } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapGetters } from 'vuex'

export default {
  components: {
    FontAwesomeIcon,
    listTableHeader,
    tabTableActions,
    contactForm
  },
  mixins: [relationship],
  watch: {
    '$store.state.form.relationshipFields': {
      handler() {
        if (
          this.relationshipItem.contactable_type &&
          !this.relationshipItem.contactable_id
        ) {
          this.relationshipItem.contactable_id = this.item.id
        }
      }
    }
  },
  data: () => ({
    loading: true,
    api: api,
    faPlusSquare,
    fields: model.fields,
    model: {
      ...JSON.parse(JSON.stringify(model.empty)),
      ...{ contactable_type: 'App\\Models\\Client' }
    },
    sortBy: 'id',
    sortDirection: 'desc',
    relationshipField: 'client_id',
    relationshipTitle: 'name'
  }),
  created() {
    this.init()
    this.loading = false
  },
  computed: {
    ...mapGetters({
      item: 'form/fields',
      relationshipItem: 'form/relationshipFields'
    }),
    visibleFields() {
      return [
        {
          key: 'name',
          label: this.$t('field.name')
        },
        {
          key: 'email',
          label: this.$t('field.email')
        },
        {
          key: 'phone',
          label: this.$t('field.phone')
        },
        {
          key: 'actions',
          label: ''
        }
      ]
    }
  }
}
</script>
